module.exports = __webpack_public_path__ + "assets/948c7590475a6927cb4e5b2d304d77eb.mp3";